import React from "react";
import "tailwindcss/tailwind.css";
import loginBg from "../../Assets/marketing.jpg";
import { useNavigate } from "react-router-dom";
import ResetForm from "./ResetForm";

const Reset = () => {
  const navigate = useNavigate();

  return (
    <div className="flex min-h-screen">
      {/* Left: Image section, hidden on small screens */}
      <div className="hidden sm:flex w-8/12 h-screen relative overflow-hidden">
        <div className="absolute inset-0 bg-gradient-to-br from-cyan-900 to-slate-900 opacity-75"></div>
        <img
          src={loginBg}
          alt="Reset Password Visual"
          className="object-cover w-full h-full filter blur-sm"
        />
      </div>
      {/* Right: Reset Password form */}
      <div className="mt-10 w-full sm:w-4/12 flex items-start justify-center p-6 bg-white">
        <ResetForm />
      </div>
    </div>
  );
};

export default Reset;
